exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[type=checkbox].filled-in:checked+span:not(.lever):after{border:2px solid #007bff!important;background-color:#007bff!important}", ""]);

